import { render, staticRenderFns } from "./MatchMakingLeaderboardSettings.vue?vue&type=template&id=23f489cb&scoped=true"
import script from "./MatchMakingLeaderboardSettings.vue?vue&type=script&lang=js"
export * from "./MatchMakingLeaderboardSettings.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingLeaderboardSettings.vue?vue&type=style&index=0&id=23f489cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f489cb",
  null
  
)

export default component.exports